import { Calendar } from '@components/common/Calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@components/common/Popover';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import { LuCalendarCheck2 } from 'react-icons/lu';

export const InterviewCalendar = ({ dateRange, setDateRange, interviewDates }) => {
    const renderDay = day => {
        const formattedDate = format(day, 'yyyy-MM-dd');
        const interviews = interviewDates.get(formattedDate);

        return (
            <Popover>
                <PopoverTrigger asChild>
                    <div className="relative">
                        {day.getDate()}
                        {interviews && (
                            <div className="absolute -top-[5px] -right-[10px] w-1 h-1 bg-blue-500 rounded-full" />
                        )}
                    </div>
                </PopoverTrigger>
                {interviews && (
                    <PopoverContent className="w-64 p-2">
                        {interviews.map(interview => (
                            <InterviewPopoverContent key={interview.id} interview={interview} />
                        ))}
                    </PopoverContent>
                )}
            </Popover>
        );
    };

    return (
        <div className="bg-slate-100 rounded-lg">
            <Calendar
                // mode="range"
                selected={dateRange}
                onSelect={setDateRange}
                className="rounded-md"
                numberOfMonths={1}
                components={{ DayContent: renderDay }}
            />
        </div>
    );
};

InterviewCalendar.propTypes = {
    dateRange: PropTypes.object,
    setDateRange: PropTypes.func,
    interviewDates: PropTypes.object,
};

const InterviewPopoverContent = ({ interview }) => {
    return (
        <div className="flex items-center gap-2 text-xs text-gray-500 mb-1">
            <div className="flex items-center gap-2">
                <LuCalendarCheck2 className="text-primary-blue text-md" />
            </div>

            <div>
                Interview with &nbsp;
                <span className="font-medium">{interview.candidate_name}</span> (
                {interview.job_title})
            </div>
        </div>
    );
};

InterviewPopoverContent.propTypes = {
    interview: PropTypes.object.isRequired,
};
